import * as messageService from "../../services/message.service";
import * as vehicleCategoryService from '../../services/vehicleCategory.service';


const state = {
    vehicleCategoryAll:[],
    vehicleCategoryAllActive:[],
};

const getters = {
    gettVehicleCategoryAll:state => (state.vehicleCategoryAll),
    gettVehicleCategoryAllActive:state => (state.vehicleCategoryAllActive),
};

const actions = {
    async fetchVehicleCategoryAll({ commit } ){
        try {
            const response = await vehicleCategoryService.all();
            commit('setVehicleCategoryAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchVehicleCategoryAllActive({ commit } ){
        try {
            const response = await vehicleCategoryService.allActive();
            commit('setVehicleCategoryAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    setVehicleCategoryAll:(state, res) => (
        state.vehicleCategoryAll =  res
    ),
    setVehicleCategoryAllActive:(state, res) => (
        state.vehicleCategoryAllActive =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}